import { Button, Card, Form, Input, Space, Typography } from "antd";
import { useEffect, useState } from "react";

import { useCustomToolStore } from "../../store/custom-tool-store";
import { updateProject } from "./simple-prompt-studio-api-service";
import useSimplePromptStudio from "../hooks/useSimplePromptStudio";
import { useAlertStore } from "../../store/alert-store";
import { useExceptionHandler } from "../../hooks/useExceptionHandler";
import { UPLOAD } from "./constants";

function SpsLanding() {
  const [projectName, setProjectName] = useState("");
  const [isStateChanged, setIsStateChanged] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { details, updateCustomTool } = useCustomToolStore();
  const { handleSpsNavigate } = useSimplePromptStudio();
  const { setAlertDetails } = useAlertStore();
  const handleException = useExceptionHandler();

  useEffect(() => {
    // Set the project name from details if not already set
    if (!projectName) {
      setProjectName(details?.tool_name || "");
    }
  }, [details]);

  const handleStateChange = (value) => {
    setProjectName(value);
    if (!isStateChanged) setIsStateChanged(true);
  };

  const handleSubmit = () => {
    if (!projectName) {
      setAlertDetails({
        type: "error",
        content: "Project name cannot be empty",
      });
      return;
    }

    setIsLoading(true);

    if (!isStateChanged) {
      // If state has not changed, simply navigate to the upload page
      handleSpsNavigate(UPLOAD);
      setIsLoading(false);
      return;
    }

    const projectId = details?.tool_id;
    const body = {
      tool_name: projectName,
    };

    // Update project with the new name
    updateProject(projectId, body)
      .then(() => {
        const updatedDetails = { ...details, tool_name: projectName };
        updateCustomTool({ details: updatedDetails });
        handleSpsNavigate(UPLOAD);
      })
      .catch((err) => {
        setAlertDetails(handleException(err));
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <div className="display-flex-center-h-and-v">
      <Card className="sps-land-card">
        <Form onFinish={handleSubmit}>
          <Space direction="vertical" size={20}>
            <div className="sps-land-header">
              <Typography.Text strong className="sps-land-title">
                What type of document are you trying to extract text or data
                from?
              </Typography.Text>
            </div>
            <div>
              <Input
                value={projectName}
                onChange={(e) => handleStateChange(e.target.value)}
              />
              <Typography.Text
                type="secondary"
                className="sps-land-helper-text"
              >
                Examples of types of documents are resumes, invoices, purchase
                orders, etc
              </Typography.Text>
            </div>
            <div>
              <Button
                type="primary"
                htmlType="submit"
                block
                loading={isLoading}
              >
                Submit
              </Button>
            </div>
          </Space>
        </Form>
      </Card>
    </div>
  );
}

export { SpsLanding };
